import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { InventoryCount } from '../model/InventoryCount';
import { InventoryCountTag } from '../model/InventoryCountTag';
import { InventoryCountSummaryDto } from '../model/dto/InventoryCountSummaryDto';

@Injectable()
export class InventoryCountFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAllInventoryCount(language: number): Observable<RequestResponse<InventoryCount[]>> {
        return this._httpClient.get<RequestResponse<InventoryCount[]>>(this._urlBase + 'api/InventoryCount/All?language=' + language);
    }

    GetAllInventoryCountByDates(startDate: string, endDate: string, language: number): Observable<RequestResponse<InventoryCount[]>> {
        return this._httpClient.get<RequestResponse<InventoryCount[]>>(this._urlBase + 'api/InventoryCount/AllByDates?startDate='
         + startDate + '&endDate=' + endDate + '&language=' + language);
    }

    GetCollectionInventoryCountByOrganizationDates(organizations: string, startDate: string, endDate: string, language: number)
        :Observable<RequestResponse<InventoryCount[]>> {
            return this._httpClient.get<RequestResponse<InventoryCount[]>>(this._urlBase + 'api/InventoryCount/AllByOrganizationDates?organizations='
             + organizations + '&startDate=' + startDate + '&endDate=' + endDate + '&language=' + language);
      }

    GetNextIdForStore(storeId: number): Observable<RequestResponse<number>> {
        return this._httpClient.get<RequestResponse<number>>(this._urlBase + 'api/InventoryCount/NextIdForStore/' + storeId);
    }

    /*
    GetReportPdf(invCountId : number, language: number): Observable<any> {
        return this._httpClient.get<any>(this._urlBase
             + 'api/InventoryCount/ReportPdf?invCountId=' + invCountId + '&language=' + language);
    }
    */

    GetReportPdf(item: InventoryCount): Observable<any> {
        return this._httpClient.post<any>(this._urlBase + 'api/InventoryCount/ReportPdf', item);
    }

    saveInventoryCount(item: InventoryCount): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/InventoryCount', item);
    }

    GetInventoryCount(id: number, language: number): Observable<RequestResponse<InventoryCount>> {
        return this._httpClient.get<RequestResponse<InventoryCount>>(this._urlBase + 'api/InventoryCount?InvCountId=' + id
        + '&language=' + language);
    }

    AddInventoryCountTag(item: InventoryCountTag): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/InventoryCountTag', item);
    }

    AddMultipleInventoryCountTag(item: InventoryCountTag[]): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/InventoryCountTag/MultipleTags', item);
    }
    DeleteInventoryCountTag(id: number): Observable<RequestResponse<boolean>> {
        return this._httpClient.delete<RequestResponse<boolean>>(this._urlBase + 'api/InventoryCountTag/' + id);
    }

    UpdateInventoryCount(item: InventoryCount): Observable<RequestResponse<number>> {
        return this._httpClient.put<RequestResponse<number>>(this._urlBase + 'api/InventoryCount', item);
    }

    GetInventoryCountSummary(id: number, language: number): Observable<RequestResponse<InventoryCountSummaryDto[]>> {
        return this._httpClient.get<RequestResponse<InventoryCountSummaryDto[]>>(this._urlBase + 'api/InventoryCount/Summary?InvCountId='
        + id + '&language=' + language);
    }

    DeleteInventoryCount(id: number): Observable<RequestResponse<number>> {
        return this._httpClient.put<RequestResponse<number>>(this._urlBase + 'api/InventoryCount/Delete', id);
    }
}
